import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { useQuery } from 'react-query';
import { BASIC_SERICES_DEACTIVATE, BASIC_SERICES_ACTIVATE } from '../../services/common/endpoints';
import { GetCacheKey } from '../../services/common/utils';
import { useDispatch } from 'react-redux';
import { setToastData } from '../../reducer/utilitySlice';
import { useTranslation } from 'react-i18next';
import Loadingcomponent from '../loader/loadingcomponent';

const BottomModalRoamingInterRates = (props) => {
    const toggleModal = props.toggleModal;
    const dispatch = useDispatch();
    const {t}  = useTranslation();
    // let crrData = props.status ? BASIC_SERICES_DEACTIVATE : BASIC_SERICES_ACTIVATE;
    let crrData = props?.roaming ? BASIC_SERICES_DEACTIVATE : BASIC_SERICES_ACTIVATE;
    const {
        data: { data } = {},
        isLoading,
        isFetching,
        refetch
    } = useQuery([GetCacheKey("Popup"), crrData, {

        msisdn: '',

        id: props.id,

        type: 'basic',

    }, {}], {
        retry: false,
        retryOnMount: false,
        staleTime: 0,
        cacheTime: 0,
        enabled: false,
        onSuccess: ({ data }) => {
            if(data?.status === '0'){
                    // props?.basicrefetch?.refetch();
                    props.check(preVal => !preVal);
            }

            toggleModal();

            dispatch(setToastData({
                show: true,
                message: data?.message,
                isIcon: true
            }));
        }
    });
    const closeModal = () => {
        refetch();
        // refetch().then(res => {
        //     dispatch(setToastData({
        //         show: true,
        //         message: res?.data?.data?.message,
        //         isIcon: true
        //     }))
        //     setTimeout(()=> {
        //     if( res?.data?.data?.status!== '-1') {
        //         props?.basicrefetch?.refetch();
        //     }}, 3000)
        // })
        // toggleModal();
    };
    return <Modal show={props.show} backdrop="true" className='bottom_modal animated  slideInUp faster' onHide={toggleModal}>
        <Modal.Body className='text-center'> 
            <div className="modal_img mb-4">
                <img src={process.env.PUBLIC_URL + '/assets/images/confirm_popup.svg'} width={60} alt="" title="" />
            </div>
            {/* <h3 className="primary_16 mb-3">Warning !</h3> */}
            {/* <p className="modal_p mb-4">{props?.status ? props?.data?.deactivate_message : props?.data?.activate_message}</p> */}
            <p className="modal_p mb-4">{props?.roaming ? props?.data?.deactivate_message : props?.data?.activate_message}</p>
            <div className='flex_grp_align_center'>
                <button type="button" className="custom_btn custom_btn_primary_outline btn_block me-2" onClick={() => toggleModal()}>{props?.data?.cancel_button}</button>
                <button className="custom_btn custom_btn_primary btn_block ms-2" onClick={() => closeModal()} disabled={isLoading || isFetching}>
                    {(isLoading || isFetching) ? <Loadingcomponent /> : t("continue")}
                </button>
            </div>
        </Modal.Body>
    </Modal>


}
export default BottomModalRoamingInterRates;